import { ColumnConfig, CFATeamInvitesColumnKey } from '../../model';

export const cfaTeamInvitesConfig: Record<
  CFATeamInvitesColumnKey,
  ColumnConfig
> = {
  user: {
    name: 'User',
    field: 'component',
  },
  role: {
    name: 'Role',
  },
  divisionsCFALocation: {
    name: 'Divisions / CFA Location',
    field: 'component',
  },
  status: {
    name: 'Invite Status',
  },
  actions: { name: '', alignment: 'flex-end' },
};
